import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/green_check_circle_64.png'
import _imports_1 from '@/assets/icons/status_warn.png'


const _withScopeId = n => (_pushScopeId("data-v-b917b08a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subscription-info" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "sub-details" }
const _hoisted_4 = { class: "sub-plan" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Subscription plan", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "sub-status" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Status", -1))
const _hoisted_9 = { class: "status-value" }
const _hoisted_10 = {
  key: 0,
  src: _imports_0
}
const _hoisted_11 = { class: "next-payment" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Next payment", -1))
const _hoisted_13 = { class: "payment-date" }
const _hoisted_14 = { class: "payment-method" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Payment method", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_19 = {
  key: 1,
  type: "button",
  class: "btn btn-inline btn-link action-link",
  "data-bs-toggle": "modal",
  "data-bs-target": "#paymentModal"
}
const _hoisted_20 = { key: 1 }

import { computed, onMounted, ref } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import { useSubscriptionStore } from '@/gp/SubscriptionStore'
import { usePaymentMethodStore } from '@/gp/PaymentMethodStore'
import { subscriptionPlans, SubscriptionStatus, defaultPlanId, PaymentMethod, Subscription, ItemPermissions } from '@/gp/GroupAdminModel'
import { DateTimeUtil } from '@/util/LuxonUtil'
import { useTokenManager } from '@/auth/TokenManager'
import numeral from 'numeral'
import PaymentCard from './PaymentCard.vue'
import PaymentModal from '@/account/PaymentModal.vue'
import SubscriptionPlanCard from './SubscriptionPlanCard.vue'
import LoadingIndicator from '@/util/LoadingIndicator.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionInfo',
  props: {
    userId: {}
  },
  setup(__props: any) {

const props = __props;



const loadingRef = ref(false)
const userPermissionsRef = ref(ItemPermissions.None)
const subRef = ref<Subscription>()
const paymentMethodRef = ref<PaymentMethod>()

const userStore = useUserStore()
const subStore = useSubscriptionStore()
const paymentMethodStore = usePaymentMethodStore()
const tokenManager = useTokenManager()

const isUserAdminRef = computed(() => (userPermissionsRef.value & ItemPermissions.Administrator) == ItemPermissions.Administrator)
const isActiveRef = computed(() => subRef.value?.status == SubscriptionStatus.Active)
const statusTextRef = computed(() => subRef.value?.status)
const priceRef = computed(() => subRef.value?.items.at(0)?.price)
const planRef = computed(() => subscriptionPlans.find(p => p.id == (priceRef.value?.productId ?? defaultPlanId)))
const isDefaultPlanRef = computed(() => planRef.value?.id == defaultPlanId)
const isPaidPlanRef = computed(() => !!planRef.value?.price)
const nextPaymentDateRef = computed(() => subRef.value?.currentPeriodEnd)
const nextPaymentAmountRef = computed(() => priceRef.value?.unitPrice)
const paymentDoomedRef = computed(() => paymentMethodRef.value?.expirationDate && nextPaymentDateRef.value && paymentMethodRef.value.expirationDate < nextPaymentDateRef.value)
const canEditRef = computed(() => props.userId == tokenManager.current.userId)

onMounted(async () => {
  try {
    loadingRef.value = true

    userPermissionsRef.value = ItemPermissions.None
    subRef.value = undefined
    paymentMethodRef.value = undefined

    userPermissionsRef.value = await userStore.getPermissionsAsync(props.userId)
    if (isUserAdminRef.value) {
      subRef.value = (await subStore.getSubscriptionListForUserAsync(props.userId)).at(0)
      paymentMethodRef.value = paymentMethodStore.getLoadedPaymentMethod(subRef.value?.paymentMethodId) // loaded with subscription
    }
  }
  finally {
    loadingRef.value = false
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loadingRef.value)
      ? (_openBlock(), _createBlock(LoadingIndicator, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              (planRef.value)
                ? (_openBlock(), _createBlock(SubscriptionPlanCard, {
                    key: 0,
                    plan: planRef.value,
                    "show-details": ""
                  }, null, 8, ["plan"]))
                : _createCommentVNode("", true),
              (isUserAdminRef.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (isPaidPlanRef.value)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: "/plans",
                          class: "btn btn-inline btn-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Change my plan")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: "/plans",
                          class: "btn btn-primary btn-sm"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Upgrade my plan")
                          ]),
                          _: 1
                        }))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (isPaidPlanRef.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      (isActiveRef.value)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(statusTextRef.value), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", null, [
                      _createTextVNode(" $" + _toDisplayString(_unref(numeral)(nextPaymentAmountRef.value).format('0.00')) + " ", 1),
                      _createElementVNode("span", _hoisted_13, " on " + _toDisplayString(_unref(DateTimeUtil).toUserActionDate(nextPaymentDateRef.value, true)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    (paymentMethodRef.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (paymentDoomedRef.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _hoisted_18,
                                _createTextVNode(" This card will expire before your next payment. ")
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(PaymentCard, { "payment-method": paymentMethodRef.value }, null, 8, ["payment-method"]),
                          (isPaidPlanRef.value)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_19, " Change "))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, "(none)"))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])),
    _createVNode(PaymentModal, {
      id: "paymentModal",
      "subscription-id": subRef.value?.id
    }, null, 8, ["subscription-id"])
  ]))
}
}

})